// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__256MR","empty":"ModalGraph_empty__3RgPr"};